import React, { useRef, useState } from 'react';
import { Menu, MenuItem, IconButton } from '@one-thd/sui-atomic-components';
import { More } from '@one-thd/sui-icons';

export interface IDropdownItemOption {
  value: string;
  onClick: () => void;
}
interface OptionsDropdownProps {
  label: string;
  options: IDropdownItemOption[];
  /**
   * Shuts the menu while something the options would start is already running.
   * The options open drawers and modals that submit; letting a second one be
   * opened over the first means two submissions for one screen.
   */
  disabled?: boolean;
}
export const OptionsDropdown = ({
  label,
  options,
  disabled = false,
}: OptionsDropdownProps) => {
  const menuBtnRef = useRef<HTMLButtonElement>(null);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <>
      <IconButton
        icon={More}
        ref={menuBtnRef}
        disabled={disabled}
        onClick={() => {
          setIsMenuOpen(!isMenuOpen);
        }}
        role="combobox"
        aria-label={`Edit ${label}`}
        aria-expanded={isMenuOpen}
        aria-controls={`edit${label}Menu`}
        aria-haspopup="listbox"
        data-testid="optionsDropdownBtn"
        iconSize="regular"
      />
      <div className="sui-font-regular sui-text-base sui-leading-tight sui-px-3 sui-whitespace-nowrap">
        <Menu
          id={`edit${label}Menu`}
          placement="bottom-end"
          open={isMenuOpen}
          anchorEl={menuBtnRef.current}
          onClose={() => {
            setIsMenuOpen(false);
          }}
        >
          {options.map(({ value, onClick }) => {
            return (
              <MenuItem
                data-testid={`option-${value}`}
                key={value}
                value={value}
                onClick={onClick}
              >
                {value}
              </MenuItem>
            );
          })}
        </Menu>
      </div>
    </>
  );
};
